import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
  Stack,
  Typography,
} from '@mui/material'
import { DeleteOutline } from '@mui/icons-material'
import { useState } from 'react'
import { ICustomer } from '@/api/services/CustomerService'
import { useDeleteCustomer } from './useDeleteCustomer'

type Props = {
  user: ICustomer
  value?: string
}

export const DeleteCustomer = ({ user }: Props) => {
  const [open, setOpen] = useState(false)
  const { deleteCustomer } = useDeleteCustomer(user.id)

  const handleClose = (event: React.MouseEvent<HTMLButtonElement | HTMLDivElement>) => {
    event.stopPropagation()
    setOpen(false)
  }

  const handleConfirmClick = (event: React.MouseEvent<HTMLButtonElement | HTMLDivElement>) => {
    event.stopPropagation()
    deleteCustomer()
    handleClose(event)
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleDelete = (event: any) => {
    event.stopPropagation()
    setOpen(true)
  }
  return (
    <>
      <IconButton color="error" aria-label="delete" onClick={event => handleDelete(event)}>
        <DeleteOutline />
      </IconButton>

      <Dialog
        fullWidth={true}
        maxWidth="xs"
        open={open}
        onClose={handleClose}
        sx={{
          width: '25rem',
          margin: '0 auto',
          '& .MuiDialog-paper': {
            borderRadius: '12px',
            boxShadow: 'none',
          },
          '& .MuiBackdrop-root': {
            backgroundColor: 'rgba(15, 15, 15, 0.1)',
          },
        }}
      >
        <Stack gap={2}>
          <DialogContent sx={{ p: 3 }}>
            <Stack gap={2}>
              <Typography
                sx={{
                  fontSize: '18px',
                  fontWeight: '600',
                  fontFamily: 'Inter',
                  lineHeight: '28px',
                  color: '#101828',
                }}
              >
                {`Are you sure you want to permanently delete this user?`}
              </Typography>
            </Stack>
          </DialogContent>
          <DialogActions sx={{ pb: 2, px: 2 }}>
            <Stack gap={1} sx={{ width: '100%' }}>
              <Button
                variant="contained"
                onClick={handleConfirmClick}
                sx={{
                  backgroundColor: '#C83532',
                  width: '100%',
                  borderRadius: '8px',
                  color: '#FFFFFF',
                  boxShadow: 'none',
                  textTransform: 'capitalize',
                  '&:hover': {
                    backgroundColor: '#C83532',
                    boxShadow: 'none',
                    cursor: 'pointer',
                  },
                }}
              >
                Yes, proceed
              </Button>
              <Button
                onClick={handleClose}
                variant="outlined"
                sx={{
                  backgroundColor: '#FFFFFF',
                  width: '100%',
                  borderRadius: '8px',
                  color: '#344054',
                  boxShadow: 'none',
                  textTransform: 'capitalize',
                  border: '1px solid #D0D5DD',
                  '&:hover': {
                    backgroundColor: 'transparent',
                    boxShadow: 'none',
                    border: '1px solid #D0D5DD',
                    cursor: 'pointer',
                  },
                }}
              >
                Cancel
              </Button>
            </Stack>
          </DialogActions>
        </Stack>
      </Dialog>
    </>
  )
}
